import React, { Component } from 'react';
import { connect } from "react-redux";

class MasonryItem extends Component {

  render() {
    return (
      this.props.cards.map((item) => {
        const divSelected = item.selected ? ' selected' : '';
        return (
          <div key={item.id} className={"card-container" + divSelected} onClick={() => this.props.updateCardData(item)}>
            <a href="#active-grid">
              <div className="staff-card">
                <img src={item.image} alt="tile" />
                <h3>{item.title}</h3>
                <div className="container">
                  <p>{item.firstcopy}{item.italics}{item.endcopy}</p>
                </div>
                <i className="fa fa-times-circle" aria-hidden="true" />
              </div>
            </a>
          </div>
        );
      })
    );
  }
}

const mapState = (state) => {
  return {
    cards: state.leadTheWay.cards,
    image: state.leadTheWay.image,
    title: state.leadTheWay.title,
    firstcopy: state.leadTheWay.firstcopy,
    italics: state.leadTheWay.italics,
    endcopy: state.leadTheWay.endcopy,
  }
};

const mapDispatch = (dispatch) => {
  return {
    updateCardData: (card) => {
      dispatch({
        type: "LEADTHEWAY_UPDATE",
        id: card.id,
        title: card.title,
        image: card.image,
        firstcopy: card.firstcopy,
        italics: card.italics,
        endcopy: card.endcopy,
      });
    }
  }
}

export default connect(mapState, mapDispatch)(MasonryItem);



// WEBPACK FOOTER //
// ./src/components/LeadTheWay/Grid/MasonryItem.js